import { Controller } from "@hotwired/stimulus";

// Figma's "Kontaktuppgifter" section only asks for email + phone -- no
// separate name fields, since the booking contact is Resenär 1 (the first
// traveler card right below it). The backend still requires
// you[firstname]/you[lastname] to be non-blank (Step2Controller
// #make_reservation_params), so this mirrors Resenär 1's own name inputs
// into the hidden you[firstname]/you[lastname] fields instead of asking
// for the same name twice.
export default class extends Controller {
  static targets = ["firstname", "lastname", "sourceFirstname", "sourceLastname"];

  sync() {
    if (this.hasSourceFirstnameTarget && this.hasFirstnameTarget) {
      this.firstnameTarget.value = this.sourceFirstnameTarget.value;
    }
    if (this.hasSourceLastnameTarget && this.hasLastnameTarget) {
      this.lastnameTarget.value = this.sourceLastnameTarget.value;
    }
  }
}
